<div fxFill fxLayout='column' [dir]="cService.selectedLanguage?.isRtl ? 'rtl' : 'ltr'">
  <vrm-dialog-header
    [dialogTitle]='dialogTitle'
    [titleDescription]='titleDescription'
    [showProgress]='showDetailsBufferProgress'
  ></vrm-dialog-header>

  <mat-dialog-content fxFlex>
    <div fxLayout='column' fxFill>
      <div fxLayout='row' *ngIf='streamSource; else documentNotAvailable' style='overflow: hidden'>
        <guide-viewer-sidepane *ngIf="fileExtension.toLowerCase() === 'pdf' && pdfDocumentReady">
          <!-- Search -->
          <form>
            <mat-form-field flex class='padding-5'>
              <input
                matInput
                type='text'
                [placeholder]="'GENERIC.searchDocument' | translate"
                aria-label='search'
                [formControl]='searchText'
              />
            </mat-form-field>
          </form>

          <!-- PDF Controls -->
          <div style='margin-top: 50px'>
            <div class='padding-10'>
              <mat-slide-toggle
                [(ngModel)]='autoresizePdf'
                fxFlex
                color='primary'
                (toggleChange)='autoresizePdf = !autoresizePdf'
                (dragChange)='autoresizePdf = !autoresizePdf'
              >
                <span fxFlex class='text-align-r'>{{ 'GENERIC.autoresize' | translate }}</span>
              </mat-slide-toggle>
            </div>

            <div class='padding-20' fxLayout='column'>
              <button mat-button class='sharp-corners' (click)='pdfZoomValue = defaultPdfZoomValue'>
                {{ 'GENERIC.resetZoom' | translate }}
              </button>
              <mat-slider
                [(value)]='pdfZoomValue'
                fxFlex
                color='primary'
                min='0.5'
                max='5'
                step='0.1'
                thumbLabel
                tickInterval='1'
              ></mat-slider>
            </div>

            <div class='margin-t-30'>
              <button
                mat-button
                class='sharp-corners bold'
                fxFlex
                *ngIf='streamSource'
                (click)='downloadFile()'
              >
                <mat-icon>file_download</mat-icon>
                {{ 'GENERIC.download' | translate | uppercase }}
              </button>
            </div>
          </div>
        </guide-viewer-sidepane>

        <div
          fxFlex
          style='overflow: auto; background-color: #ccc'
          *ngIf="fileExtension.toLowerCase() === 'pdf'"
        >
          <pdf-viewer
            [autoresize]='autoresizePdf'
            [show-all]='true'
            [zoom]='pdfZoomValue'
            [stick-to-page]='true'
            [render-text]='true'
            [external-link-target]="'blank'"
            [show-borders]='true'
            [(page)]='currentPdfPage'
            (after-load-complete)='pdfDocumentLoaded($event)'
            [src]='streamSource'
            [render-text]='true'
          >
          </pdf-viewer>
        </div>

        <div fxFlex style='overflow: auto' class='text-align-c' *ngIf="fileExtension.toLowerCase() === 'mp4'">
          <vrm-video-player [src]='streamSource'></vrm-video-player>
        </div>
      </div>

      <ng-template #documentNotAvailable>
        <div class='text-align-c' style='margin-top: 20vh'>
          <h4 *ngIf='showDetailsBufferProgress'>{{ 'MESSAGESANDWARNINGS.working' | translate }}...</h4>
          <h4 class='red-text' *ngIf='resourceReadyOrFailed'>
            :: {{ 'MESSAGESANDWARNINGS.unableToOpenResource' | translate }}
          </h4>
        </div>
      </ng-template>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions style='padding: 0px'>
    <!-- Footer -->
    <div fxLayout='column' fxFlex>
      <mat-divider></mat-divider>

      <div fxLayout='row' fxFlex>
        <span fxFlex></span>

        <button mat-button mat-dialog-close class='sharp-corners bold'>
          {{ 'GENERIC.close' | translate | uppercase }}
        </button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
